<template>
  <div class="login2">
    <div class="wrap">
      <el-form :model="numberValidateForm" ref="numberValidateForm" :rules="rules2" label-width="100px"
               class="demo-ruleForm">
        <div class="title">
          <div>宝洁CRM</div>
          <div>通过验证后才能浏览该网站内容</div>
          <img src="../common/images/矢量智能对象.png" alt="">
        </div>
        <!-- <el-form-item prop="account">
          <el-input v-model="numberValidateForm.account" auto-complete="off" placeholder="请输入账号"></el-input>
        </el-form-item> -->
        <el-form-item prop="checkPass">
          <!--非常奇怪，这里的enter事件会被浏览器截获，在submit请求结束之前跳转页面，被逼在enter事件上加了个.prevent-->
          <el-input type="password" v-model="numberValidateForm.checkPass" auto-complete="off" placeholder="请输入密码"
                    @keydown.enter.prevent.native="submitForm('numberValidateForm')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="submitForm('numberValidateForm')">登陆</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import utils from '../common/js/util'

  export default {
    data() {
      return {
        numberValidateForm: {
          account: '',
          checkPass: ''
        },
        rules2: {
          account: [
            {required: true, message: '请输入账号', trigger: 'blur'},
            //{ validator: validaePass }
          ],
          checkPass: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            //{ validator: validaePass2 }
          ]
        },
        projectPass: 'mecoolbu5',//项目密码
        userPass: '17mecool18',//客户密码
        canNotLogin: 0,//已经由于上个账号未注销而无法登陆的次数
      };
    },
    methods: {
      submitForm() {
        this.$refs.numberValidateForm.validate((valid) => {
          if (valid) {
            let password = this.numberValidateForm.checkPass
            if (password == 'mecoolbu5' || password == '17mecool18') {
              let account = password == 'mecoolbu5' ? 'PGproject' : 'PGclient'

              this.$http({
                method: "post",
                url: '/rest/auth/login',
                headers: {'Content-type': 'application/x-authc-username-password+json'},
                data: {
                  user: account,
                  password: password
                }
              }).then(res => {
                //因为后台不允许同一个客户端登录两个账号，所以如果登陆了一个账号这里就提示他需要先注销
                //当前请求登录的账号和服务端返回的‘已经登录的账号’名称不匹配时，则判定是第二次登陆
                if (res.data.loginName != account) {
                  if (this.canNotLogin <= 1) {
                    this.$alert('您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆，本次登录无效', '提示', {type: 'error'})
                  } else {
                    this.$confirm('您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆,  是否强制注销?', '提示', {
                      type: 'warning'
                    }).then(() => {
                      this.$http.post('/rest/auth/logout').then(res => {
                        utils.myNotify(this, 'success', res, '注销成功') //有时候提示该用户未登入，此时code是一串字母，但我们仍然提示注销成功
                        sessionStorage.clear()
                        setTimeout(() => {
                          location.reload(true)
                        }, 1000)
                      }).catch(err => {
                        utils.myNotify(this, 'warning', err.response, '注销失败')
                      })
                    }).catch(() => {})
                  }
                  this.canNotLogin += 1;
                } else {
                  //正常情况下直接登录
                  sessionStorage.setItem('nickname', String(res.data.nickname))
                  sessionStorage.setItem("usersPG", String(account));
                  sessionStorage.setItem("passwordsPG", String(password));
                  this.$router.push({path: '/salespersonLibrary'});
                }
              }).catch(err => {
                utils.myNotify(this, 'error', err.response, '无法登录系统，输入的账户或密码有误！')
              })
            } else {
              utils.myNotify(this, 'error', '您输入的账户或密码有误！')
            }
          }
        })
      },
    },
    mounted() {
      document.title = '宝洁CRM'
    },
    destroyed() {
      window.onkeydown = null;
    }
  }


</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 314px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 35px 0px;
    }
  }

  body {
    background: #1F2D3D;
  }

  .title {
    text-align: center;
    background: #3DA879;
    font-size: 16px;
    font-family: '微软雅黑';
    color: #fff;
    margin: 40px 40px 20px;
    height: 40px;
    line-height: 40px;
    padding: 0;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login2.vue